import type { ReactNode } from 'react';

import type { OptionBoxFieldConfig } from '../../config';
import type { SectionKey } from '../../lease-details.types';
import { LeaseOptionBoxInput } from '../../inputs/lease-option-box';
import { useFieldEventContextBuilder } from '../use-field-event-context';

export type OptionBoxFieldProps = {
  path: string;
  field: OptionBoxFieldConfig;
  sectionKey: SectionKey;
  arrayIndex?: number;
  required: boolean;
  disabled: boolean;
  label: ReactNode;
};

export const OptionBoxField = ({
  path,
  field,
  sectionKey,
  arrayIndex,
  required,
  disabled,
  label,
}: OptionBoxFieldProps) => {
  const buildContext = useFieldEventContextBuilder<string>(path, sectionKey, arrayIndex);
  return (
    <LeaseOptionBoxInput
      name={path}
      options={field.options}
      label={typeof label === 'string' ? label : undefined}
      companionIdField={field.companionIdField}
      layout={field.layout}
      useDrawerStyles={field.useDrawerStyles}
      skeletonCount={field.skeletonCount}
      required={required}
      disabled={disabled}
      onSelect={
        field.events?.onChange
          ? ({ value, optionId }) => field.events?.onChange?.(buildContext(value, optionId))
          : undefined
      }
    />
  );
};
